import React from 'react';

import { ProductItem } from '../eshop/';
import trads from './trads';

import { Wrapper, Grid, Title } from './Recommendations.styles';
import { useLocale } from '../../services/i18n/useLocale';

const Recommendations = ({
  recommendations = [],
  showTitle = false,
  maxItems = 4,
  className,
}) => {
  const intl = useLocale();

  let recos = recommendations.slice(0, maxItems);

  return (
    <Wrapper className={className}>
      {showTitle ? (
        <Title>{intl.formatMessage(trads.recommendation)}</Title>
      ) : null}
      <Grid className="product-grid">
        {recos.map((reco, idx) => (
          <ProductItem
            key={reco.id}
            {...reco}
            trackList="Similar Products"
            trackPosition={idx + 1}
          />
        ))}
      </Grid>
    </Wrapper>
  );
};

export default Recommendations;
